import { createSlice } from '@reduxjs/toolkit'

import { SLICES } from '@/reducers/utils/constants'

import { extraReducers, reducers } from './reducers'

const initialState = {
  isSubmitting: false
}

const promoCampaigns = createSlice({
  extraReducers: extraReducers,
  initialState,
  name: SLICES.promoCampaigns,
  reducers: reducers
})

export const { actions } = promoCampaigns
export default promoCampaigns
